import { EnergyDetailsForm } from '@features/EnergyDetailsForm';
import { withProfiler } from '@services/sentry/withProfiler';

const EnergyDetails = withProfiler(EnergyDetailsForm);

export { EnergyDetails };
